/* @flow strict */

/* eslint-disable camelcase */

import * as React from 'react';
import Modal from '/client/src/components/Modal';
import SimpleInput from '/client/src/components/forms/simpleInput';
import _ from 'lodash';
import { emailRegexp } from '/client/src/constants';

type PropsType = {
  handleSubmit: () => void,
  handleClose: () => void,
  isOpen: boolean,
  isPending: boolean,
  userToEdit?: any
};

const CreateUserModal = ({
  handleSubmit,
  handleClose,
  isOpen,
  isPending,
  userToEdit
}: PropsType): React.Element<'div'> => {
  const [users, setUsers] = React.useState([userToEdit || {}]);

  // only one user validation
  const [isMachEmail, setMachEmail] = React.useState(false);
  const [isChangedEmail, setChangedEmail] = React.useState(false);
  const [isChangeFirstName, setChangeFirstName] = React.useState(false);
  const [isMachFirstName, setMachFirstName] = React.useState(false);
  const [isChangeLastName, setChangeLastName] = React.useState(false);
  const [isMachLastName, setMachLastName] = React.useState(false);

  {/* TODO: don't doing now */}
  // const handleAddNewUser = (): void => setUsers([...users, {}]);

  const handleChangeUserData = (key: number, field: string, value: string) => {
    const newData = [...users];

    newData[key] = {
      ...newData[key],
      [field]: value
    };

    setUsers(newData);
  };

  if (!!userToEdit) {
    React.useEffect(() => {
      setMachEmail(true);
      setChangeFirstName(true);
      setChangeLastName(true);
      setMachFirstName(_.size(users[0].first_name) > 0);
      setMachLastName(_.size(users[0].last_name) > 0);
    }, []);
  }

  return (
    <Modal
      overflow='visible'
      opened={isOpen}
      onClose={handleClose}
      altView
      isScrollable
    >
      <div className="modal-dialog customModal modal-table-filter EventPageSponsorModal" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h4 className="modal-title">
              {!_.size(userToEdit) ?
                <span>Add Sponsor LogIn</span>
                :
                <span>Edit Sponsor LogIn Name</span>
              }

            </h4>
          </div>
          <div className="modal-body">
            {_.map(users, (item: {}, key: number): React.Element<'div'> => {
              return (
                <div key={key}>
                  { !_.size(userToEdit) &&
                    <SimpleInput
                      label='Login email'
                      name={`createUserEmail_${key}`}
                      id={`createUserEmail_${key}`}
                      placeholder='Email'
                      type='text'
                      value={users[key].email}
                      onChange={(e: any) => {
                        setChangedEmail(true);
                        setMachEmail(emailRegexp.test(e.target.value));
                        handleChangeUserData(key, 'email', e.target.value);
                      }}
                      forceShowValidator={!isMachEmail}
                      validator={isChangedEmail ? {
                        text: <i className='glyphicon glyphicon-warning-sign' />
                      } : false}
                    />
                  }
                  <SimpleInput
                    label='First name'
                    name={`createUserFirstName_${key}`}
                    id={`createUserFirstName_${key}`}
                    placeholder='First name'
                    type='text'
                    value={users[key].first_name}
                    onChange={(e: any) => {
                      setChangeFirstName(true);
                      setMachFirstName(_.size(e.target.value) > 0);
                      handleChangeUserData(key, 'first_name', e.target.value);
                    }}
                    forceShowValidator={!isMachFirstName}
                    validator={isChangeFirstName ? {
                      text: <i className='glyphicon glyphicon-warning-sign' />
                    } : false}
                  />
                  <SimpleInput
                    label='Last name'
                    name={`createUserLastName_${key}`}
                    id={`createUserLastName_${key}`}
                    placeholder='Last name'
                    type='text'
                    value={users[key].last_name}
                    onChange={(e: any) => {
                      setChangeLastName(true);
                      setMachLastName(_.size(e.target.value) > 0);
                      handleChangeUserData(key, 'last_name', e.target.value);
                    }}
                    forceShowValidator={!isMachLastName}
                    validator={isChangeLastName ? {
                      text: <i className='glyphicon glyphicon-warning-sign' />
                    } : false}
                  />
                </div>
              );
            })}
            {/* TODO: don't doing now */}
            {/* <button* /}
            {/*  type="button"*/}
            {/*  className={'btn btn-pink actionBtn'}*/}
            {/*  onClick={(): void => handleAddNewUser()}*/}
            {/* >New</button> */}
          </div>
          <div className="modal-footer">
            <button className="btn btn-gray" onClick={handleClose}>Cancel</button>
            {!_.size(userToEdit) ?
              <button
                className={`btn btn-pink actionBtn
                ${!isPending && isMachEmail && isMachFirstName && isMachLastName ? '' : 'is-disabled'}
                `}
                onClick={(): void => handleSubmit(users)}
              >Add</button>
              :
              <button
                className={`btn btn-pink actionBtn
                ${!isPending &&
                isMachFirstName &&
                isMachLastName &&
                (isChangeFirstName || isChangeLastName) ? '' : 'is-disabled'}
                `}
                onClick={(): void => handleSubmit(users[0])}
              >Save</button>
            }
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default CreateUserModal;
